import React from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import Image from '../img/building_purple.png';
import "./Home.css";
import { useTheme } from './ThemeContext';
import DarkMode from '../img/DarkMode.GIF';
import LightMode from '../img/LightMode.GIF';

export function Home() {
    /* static displayName = Home.name;*/
    const isAuthenticated = useIsAuthenticated();
    const { theme, toggleTheme } = useTheme();
    const StatsPortalUrl = () => {
        window.location.href ='https://statistics.reinz.co.nz/main/landing'
    }
    return (

        <>
            <div id="Home" className="row">
                <div className="column">
                    <h1>REINZ Returns PORTAL</h1>
                    <p>Returns portal</p>
                    <button className="btnClass" onClick={StatsPortalUrl}>
                        <i className="bi bi-arrow-left-square" style={{ marginRight: "8px", height:"1px" }}></i>
                    Back to Stats Portal
                </button>
                </div>
                <div className="column">
                    <img src={theme === 'light' ? LightMode : DarkMode} style={{ width: "100%" }} />
                </div>
            </div>
        </>
    );
}
